import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomePage } from './home/home.page';

const routes: Routes = [
  { path: 'private', redirectTo: '' },
  { path: 'legacyhome', component: HomePage },
  { path: '', pathMatch: 'full', loadChildren: './private/private.module#PrivateModule' },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
